import { render, staticRenderFns } from "./contr.vue?vue&type=template&id=fb4dc51e&scoped=true&"
import script from "./contr.vue?vue&type=script&lang=tsx&"
export * from "./contr.vue?vue&type=script&lang=tsx&"
import style0 from "./contr.vue?vue&type=style&index=0&id=fb4dc51e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4dc51e",
  null
  
)

export default component.exports